/**
* Nested content cars, in rows multiple tiers
*
*/

import $ from 'jquery';
import verge from 'verge';

let ScrollMagic = require('scrollmagic');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
require('gsap/src/uncompressed/plugins/ScrollToPlugin.js');
require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators');

// Init ScrollMagic controller
const controller = new ScrollMagic.Controller();

$.extend(verge);

// Cached elements
const $el = {
	listContainer: $('.js-expandable-cards-list'),
	listItem: $('.js-expandable-card'),
	cardButton: $('.js-expandable-card-button'),
	cardContent: $('.js-expandable-card-content'),
	closeButton: $('.js-expandable-card-close-button'),
	dropdownOptions: $('.js-show-options'),
	dropdownOptionsContainer: $('.js-show-options-container'),
	indicator: $('.js-expandable-card-indicator')
};

const vars = {
	VPW: 0,
	containerWidth: 1180
};

// Module events
export default function init() {
	if (!$el.listContainer.length) return;
	
	updateVPW();
	setBoundaries();
	updateIndicatorColor();
	
	// Loop list items
	$el.listItem.each(function() {
		listItemBindEvents($(this));
	});
	
	bindEvents();
}

function setBoundaries() {
	
	if (vars.VPW > vars.containerWidth + 60) {
		const margins = ((vars.VPW - vars.containerWidth) / 2);
		
		// Nudge every 1st and fourth item in the list along
		// this makes the layout
		$('.js-expandable-cards-list li:nth-child(4n+1) > .js-expandable-card-button').css('marginLeft', margins);
		
	} else {
		$el.cardButton.attr('style', '');
	}
	
	$el.listContainer.removeClass('is-loading');
	
}

export function resize() {
	if (!$el.listContainer.length) return;
	
	updateVPW();
	setBoundaries();
}

function updateVPW() {
	vars.VPW = $.viewportW();
}

function listItemBindEvents($listItem) {
	$listItem.on('click', '.js-expandable-card-button', function() {
		const $card = $(this);
		const $content = $card.next($el.cardContent);
		
		// Check if card is currently open, if so then close it.
		if ($card.hasClass('is-expanded')) {
			closeCard($card, $content);
		} else {
			closeSiblingCards($listItem);
			openCard($card, $content);
		}
	});
}

function bindEvents() {
	// If user clicks outside of staff list, close currently open staff card(s).
	$(document).on('click', function() {
		if (!$el.listContainer.hasClass('has-expanded-card')) return;
		if (!$(event.target).closest($el.listContainer).length) {
			closeAllCards();
		}
	});
	
	$el.closeButton.on('click', function() {
		const $listItem = $(this).closest($el.listItem);
		
		if ($listItem.hasClass('has-expanded')) {
			const $card = $listItem.find($el.cardButton);
			const $content = $listItem.find($el.cardContent);
			
			closeCard($card, $content);
		}
	});
}

function openCard($card, $content) {

	$card.closest($el.listItem).addClass('has-expanded');
	$content.addClass('is-expanded');
	
	// Display current card's content.
	$content.slideDown(500, 'easeInOutQuart', function() {
		// $card.addClass('is-expanded');
		$el.listContainer.addClass('has-expanded-card');
		
		if ($content.find($el.dropdownOptions).length) {
			showDropdownOptions();
		}
	});
	
	setTimeout(() => {
		// We need to hide the indicator before it closes fully
		$card.addClass('is-expanded');
		// Scroll to card
		scrollToSections($card);
	}, 200);
	
}

function closeCard($card, $content) {
	
	$card.closest($el.listItem).removeClass('has-expanded');
	$content.removeClass('is-expanded');
	
	// Hide current card's content.
	$content.slideUp(500, 'easeInOutQuart', function() {
		// $card.removeClass('is-expanded');
		$el.listContainer.removeClass('has-expanded-card');
	});
	
	// We need to hide the indicator before it closes fully
	setTimeout(() => {
		$card.removeClass('is-expanded');
	}, 200);
	
}

function closeAllCards() {
	// Hide any currently visible card content.
	$el.cardButton.removeClass('is-expanded');
	
	$el.cardContent.slideUp(500, 'easeInOutQuart', function() {
		$(this).removeClass('is-expanded');
	});
	
	$el.listItem.removeClass('has-expanded');
	$el.listContainer.removeClass('has-expanded-card');
}

function closeSiblingCards($thislistItem) {
	// Close other cards from this level
	const $siblings = $thislistItem.siblings();
	
	$siblings.not($thislistItem).each(function() {
		const $card = $(this).find($el.cardButton);
		const $expandableContent = $(this).find($el.cardContent);
		closeCard($card, $expandableContent);
	});
}

function updateIndicatorColor() {
	
	$el.cardButton.each(function() {
		const indicatorColor = $(this).closest('li').find($el.cardContent).css('backgroundColor');
		
		$(this).find($el.indicator).css('borderBottomColor', indicatorColor);
	});
	
}

function showDropdownOptions() {
	$el.dropdownOptions.each(function() {
		const $this = $(this);
		
		$this.on('change', () => {
			const dropdownValue = $this.val();
			const $boxToShow = $(`#${dropdownValue}`);
			
			$el.dropdownOptionsContainer.not($boxToShow).slideUp({
				easing: 'easeInOutQuart'
			});
			
			$boxToShow.slideDown({
				easing: 'easeInOutQuart'
			});
		});
		
	});
}

function scrollToSections($card) {
	
	// const scrollOffset = $card;
	const scrollOffset = $card.offset().top - getScrollOffset();

	TweenMax.to(window, 0.5, {
		scrollTo: {
			y: scrollOffset, // Add the 1px so that it highlights the nav as it's 'inside' the target
			autoKill: true, // allows user to kill scroll action smoothly
		},
		ease: Cubic.easeInOut
	});

}

function getScrollOffset() {
	
	if (($(window).width() < 952)) {
		return $('.c-top-bar').outerHeight() + 20;
	}
	
	return 20;
}
